import InlineSvg from 'approot/shared/inline-svg/inline-svg';
import {
  SwitchStyled,
  SwitchActiveStyled,
  SwitchInactiveStyled,
} from './switch.style';

type Props = {
  state: boolean;
  ariaLabel: string;
  onClick?: () => void;
  className?: string;
};

const Switch = ({ state, ariaLabel, onClick, className, ...rest }: Props) => {
  const isReadOnly = !onClick;
  return (
    <SwitchStyled
      data-selector="switch"
      type="button"
      role="switch"
      data-state={state}
      data-clickable={!isReadOnly}
      aria-checked={state}
      aria-label={ariaLabel}
      aria-readonly={isReadOnly}
      onClick={onClick}
      className={className}
      {...rest}
    >
      <span aria-hidden />
      <SwitchActiveStyled aria-hidden>
        <InlineSvg id="icon_switch_on" width={10} height={10} />
      </SwitchActiveStyled>
      <SwitchInactiveStyled aria-hidden>
        <InlineSvg id="icon_switch_off" width={10} height={10} />
      </SwitchInactiveStyled>
    </SwitchStyled>
  );
};

export default Switch;
